<template>
  <div id="addSearch-container">
    <!-- Libraries -->
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/addsearch-search-ui@0.7.1/dist/addsearch-search-ui.min.css"
    />

    <div id="addSearch-input-wrapper">
      <v-row v-if="context && context.properties && context.properties.key">
        <v-col cols="12" class="pr-0 d-flex justify-start">
          <!-- Containers for UI components-->
          <div id="searchfield-container"></div>
          <div id="autocomplete-container"></div>
        </v-col>
      </v-row>
    </div>
    <template
      v-if="context && context.properties && context.properties.key && results"
    >
      <div class="adds-components">
        <div class="adds-results-main-wrapper">
          <!-- (4) Search results UI components -->
          <div class="adds-filters-wrapper">
            <!-- Filters UI components -->
            <div class="adds-filters-main-wrapper adds-close">
              <div class="text-right d-md-none">
                <v-btn
                  class="mt-1"
                  small
                  @click="toggleFilterOptions"
                  :color="filterList ? 'grey' : 'primary'"
                  fab
                >
                  <v-icon color="white" v-show="filterList"
                    >mdi-filter-variant-remove</v-icon
                  >
                  <v-icon color="white" v-show="!filterList"
                    >mdi-filter-variant-plus</v-icon
                  >
                </v-btn>
              </div>

              <div v-show="filterList" class="filters-inner-wrapper">
                <!-- Filters here -->
                <!-- filter templates -->
                <div id="selected-filters-container"></div>
                <div class="addsearch-facets adds-filters-group">
                  <div class="adds-filter-parent-container">
                    <div id="facets-container-category">
                      <div class="addsearch-facets adds-filters-group">
                        <h4 class="adds-filter-title">Resources</h4>
                        <div id="facets-container-category-inner"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- filter templates -->
              </div>
            </div>
          </div>
          <div class="adds-results-wrapper">
            <!-- (5) Main results components -->
            <div id="sortby">
              <span class="pt-2 d-none">Sort By:</span>
              <div id="sortby-inner"></div>
            </div>
            <div id="searchresults-container"></div>
            <!-- Results component -->
            <div id="pagination-container"></div>
            <!-- Paging component -->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddSearch",

  props: {
    results: {
      type: Boolean,
    },
    context: {
      type: Object,
    },
  },

  data() {
    return {
      baseFilters: null,
      loggedUser: false,
      filterList: true,
    };
  },

  async created() {
    if (process.env.VUE_APP_TYPE === "widget") {
      // Check which sections allowed for this KEY
      await this.checkSections();
      await this.init();
    } else {
      if (this.$store.getters["auth/getUser"]) {
        this.loggedUser = true;
      }
      await this.init();
    }
  },

  methods: {
    toggleFilterOptions() {
      this.filterList = !this.filterList;
    },

    async checkSections() {
      if (this.context.restrict && this.context.restrict.length) {
        let baseFilters = {
          or: [],
        };
        this.context.restrict.forEach(function (one) {
          baseFilters.or.push({ "custom_fields.category": `${one}` });
        });
        this.baseFilters = baseFilters;
      }

      return;
    },

    async init() {
      const _self = this;

      function getJs() {
        _self
          .$loadScript(
            "https://cdn.jsdelivr.net/npm/addsearch-js-client@0.8/dist/addsearch-js-client.min.js"
          )
          .then(() => {
            return true;
          });
      }

      function getUI() {
        // TODO: check version
        _self
          .$loadScript(
            "https://cdn.jsdelivr.net/npm/addsearch-search-ui@0.7/dist/addsearch-search-ui.min.js"
          )
          .then(() => {
            return true;
          });
      }

      axios
        .all([getJs(), getUI()])
        .then(() => {
          setTimeout(() => {
            if (_self.context && _self.context.properties) {
              _self.run();
            }
          }, 1000);
        })
        .catch((e) => {
          console.error(e);
        });
    },

    run() {
      const _self = this;
      // AddSearch JS client instance
      /* eslint-disable */
      const client = new AddSearchClient(_self.context.properties.key);

      if (client) {
        //client.setPaging(1, 30, 'relevance', 'desc');
        client.setSearchOperator("and");
        // Search UI
        let destination = "/search";

        if (process.env.VUE_APP_TYPE === "widget") {
          destination = "#" + destination;
        }

        let conf = {
          //matchAllQuery: true,
          searchResultsPageUrl: destination,
        };

        if (process.env.VUE_APP_TYPE === "widget") {
          if (this.baseFilters) {
            conf["baseFilters"] = this.baseFilters;
          }
        }

        client.setNumberOfFacets(25);
        client.addFacetField("custom_fields.category");

        // Search UI instance
        /* eslint-disable */
        const searchui = new AddSearchUI(client, conf);

        if (searchui) {
          searchui.searchField({
            containerId: "searchfield-container",
            autofocus: true,
            placeholder: "Keyword ...",
            button: "",
            searchAsYouType: false,
          });

          // Align autocomplete with search field
          function alignAutocomplete(container) {
            const autocomplete = container.querySelector(
              ".addsearch-autocomplete"
            );
            const searchfield = document.querySelector(
              "#searchfield-container input"
            );
            const searchBtn = document.querySelector(
              "#searchfield-container button"
            );

            if (autocomplete && searchfield) {
              autocomplete.style.top =
                searchfield.getBoundingClientRect().height + 10 + "px";
              // autocomplete.style.left = searchfield.getBoundingClientRect().left + 'px';
              autocomplete.style.right =
                searchBtn.getBoundingClientRect().width + 15 + "px";
              autocomplete.style.width =
                searchfield.getBoundingClientRect().width + "px";
            }
          }

          searchui.autocomplete({
            containerId: "autocomplete-container",
            onShow: alignAutocomplete,
            sources: [
              {
                type: AddSearchUI.AUTOCOMPLETE_TYPE.SUGGESTIONS,
              },
            ],
          });

          // Templates
          let searchResultTemplate = `
   <div class="addsearch-searchresults">
    {{#if resultcount}}
      {{> numberOfResultsTemplate }}
    {{/if}}
    <div class="adds-hits-main-wrapper">
    {{#each hits}}
      <div class="adds-hit{{#equals type "PROMOTED"}} promoted{{/equals}}">
        <div class="adds-hit-wrapper" {{#if style}} style="background-color:{{style.background_color}}"{{/if}}>
           <div class="adds-hit-top">
               <div class="adds-main-image {{document_type}} {{#unless images.main}}noimage{{/unless}}"{{#if images.main}} style="background-image: url(data:image/jpeg;base64,{{images.main_b64}})"{{/if}}>
                {{#if images.main}}
                <div class="adds-aspect">
                <img src="{{images.main}}" alt="{{title}}" /></div>
                {{else if style.image_url}}<div class="adds-aspect">
                <img src="{{style.image_url}}" alt="{{title}}" /></div>{{/if}}
             </div>
           </div>
            <div class="adds-hit-bottom">
              <h2 class="adds-hit-title">
                <a class="adds-hit-title-link" href="{{url}}" {{#if style}} style="color:{{style.text_color}}!important"{{/if}}>
                   {{#if title}}
                    {{title}}
                   {{else}}
                      {{url}}
                    {{/if}}
                </a>
            </h2>
              <div class="adds-highlight" {{#if style}} style="color:{{style.text_color}}!important"{{/if}}>
                {{#if custom_fields.summary}}
                {{custom_fields.summary}}
                {{else}}
                {{{highlight}}}...
                {{/if}}

                {{#if custom_fields.type}}
                  {{#equals custom_fields.type "Free"}}
                    <span class="adds-category free-red">
                      FREE
                    </span>
                  {{/equals}}
                {{/if}}

              </div>

                <div style="display: inline;">
                  {{#if custom_fields.category}}
                        <span class="adds-category resources">
                          {{custom_fields.category}}
                        </span>
                  {{/if}}

                  {{#if custom_fields.modified}}
                        <span class="adds-category">
                          {{formatDate custom_fields.modified}}
                        </span>
                  {{/if}}
                </div>

              </div>
          </div>
      </div>
    {{/each}}
    </div>
  </div>
`;

          const NUMBER_OF_RESULTS_TEMPLATE = `
  <div class="number-of-results">
    {{#gt page 1}}Page {{../page}} of {{/gt}}
    {{total_hits}}{{#equals total_hits 10000}}+{{/equals}} results for <em>{{keyword}}</em>
  </div>
`;

          let selectedFiltersTemplate = `
    <div class="addsearch-active-filters">
        {{#each active}}
        <div class="item">
        <span>{{label}}</span>
            <button data-type="{{type}}" data-name="{{name}}" data-value="{{value}}">&#215;</button>
        </div>
        {{/each}}
        {{#if clearAll}}
            {{#gt active.length 1}}
                <div class="item"><button data-clearall="true">Clear all</button></div>
            {{/gt}}
        {{/if}}
    </div>
`;

          function createCategTemplate() {
            return `
        <ul class="adds-filter-parent-container">
         {{#each facets}}
          <li data-facet="{{value}}" class="adds-sub-filter-title">
            <label class="adds-label">
              <input type="checkbox" value="{{value}}" class="adds-checkbox" />
              <span class="adds-value">{{value}}</span>
              <em class="adds-count">({{count}})</em>
            </label>
          </li>
          {{/each}}
       </ul>
  `;
          }

          // Add components
          if (document.getElementById("sortby")) {
            searchui.sortBy({
              containerId: "sortby-inner",
              options: [
                {
                  label: "Relevance",
                  sortBy: "relevance",
                  order: "desc",
                },
                {
                  label: "Newest First",
                  sortBy: "custom_fields.modified",
                  order: "desc",
                },
                {
                  label: "Oldest First",
                  sortBy: "custom_fields.modified",
                  order: "asc",
                },
              ],
              options_b: [
                {
                  label: "Relevance",
                  sortBy: "relevance",
                  order: "desc",
                },
                {
                  label: "Date: Newest first",
                  sortBy: "date",
                  order: "desc",
                },
                {
                  label: "Date: Oldest first",
                  sortBy: "date",
                  order: "asc",
                },
              ],
            });
          }

          if (document.getElementById("searchresults-container")) {
            searchui.searchResults({
              containerId: "searchresults-container",
              template: searchResultTemplate,
              template_resultcount: NUMBER_OF_RESULTS_TEMPLATE,
            });
          }

          if (document.getElementById("selected-filters-container")) {
            searchui.activeFilters({
              containerId: "selected-filters-container",
              template: selectedFiltersTemplate,
            });
          }

          if (document.getElementById("facets-container-category")) {
            let filterTemplateCategory = createCategTemplate();
            searchui.facets({
              containerId: "facets-container-category-inner",
              field: "custom_fields.category",
              sticky: true,
              template: filterTemplateCategory,
            });
          }

          if (document.getElementById("pagination-container")) {
            searchui.pagination({
              containerId: "pagination-container",
            });
          }

          searchui.registerHandlebarsHelper("formatDate", function (string) {
            if (string != null) {
              var date = new Date(string);
              var formattedDate = date.toISOString().split("T")[0];
              return formattedDate;
            }
          });

          // Start after all components are added
          searchui.start();
        }
      }
    },
  },
};
</script>

<style>
#addSearch-input-wrapper .addsearch-searchfield-container input[type="search"].icon {
  padding: 0 7px 2px 32px !important;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic2VhcmNoLWljb24iIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjYjFiMWIxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik05Ljg4MiA2LjA3YTQuMDk3IDQuMDk3IDAgMDE0LjA5NC00LjA5NCA0LjA5NyA0LjA5NyAwIDAxNC4wOTUgNC4wOTUgNC4wOTcgNC4wOTcgMCAwMS00LjA5NSA0LjA5NGMtMi4yNTgtLjA0Ny00LjA5NC0xLjg4My00LjA5NC00LjA5NG0xMC4wMjQgMEE1Ljk4NSA1Ljk4NSAwIDAwMTMuOTI5LjA5NEMxMC42ODIuMDk0IDggMi43NzYgOCA2LjA3MWE1Ljk4NSA1Ljk4NSAwIDAwNS45NzYgNS45NzZjLjU2NSAwIDEuMDgzLS4wOTQgMS41NTMtLjIzNWwxLjc4OSAzLjk1MyAxLjY5NC0uOC0xLjc4OC0zLjk1M2MxLjY0Ny0xLjA4MyAyLjY4Mi0yLjg3IDIuNjgyLTQuOTQxTTQgMi45NjVIMi4xMTh2Mi4xNjRIMHYxLjgzNmgyLjExOHYyLjE2NEg0VjYuOTY1aDIuMTE4VjUuMTI5SDR6Ii8+PC9nPjwvc3ZnPg==");
  background-position: 5px 50%;
  background-repeat: no-repeat;
  height: 36px;
  width: 100%;
  font-size: 16px;
  border: 1px solid #dedede;
  border-radius: 5px;
  text-align: left;
  margin-right: 3px;
}

#addSearch-input-wrapper .addsearch-searchfield-container input[type="search"].icon {
  color: #333333 !important;
  min-width: 100px !important;
  max-width: 200px !important;
}

#addSearch-input-wrapper .addsearch-searchfield-container button {
  display: none !important;
}

.addsearch-sidebar-container {
  display: block;
}

.addsearch-mobile-sidebar label {
  font-weight: bold;
}

.addsearch-searchresult-container {
  overflow: hidden;
  display: block;
}

#autocomplete-container .suggestions li {
  margin-bottom: 5px;
}

.addsearch-mobile-sidebar-container {
  position: relative;
  width: 100%;
}

.addsearch-mobile-sidebar {
  border: solid 1px #cccccc;
}

.addsearch-pagination button[data-active="true"] {
  background: #00746b !important;
  border: 1px solid #00746b !important;
  color: #fff !important;
}

#searchresults-container .addsearch-searchresults .adds-hits-main-wrapper .adds-hit .adds-category.free-red {
  color: red;
}

#addSearch-container .adds-filter-parent-container input {
  width: auto;
  max-width: 20px;
  margin-bottom: 0;
}

#addSearch-container .addsearch-facets ul {
  margin-left: 0;
}
</style>
